import { CharObject } from './charobject';
import { debugValidateProps } from '../util/generic';
import { ABILTYPE } from '../gamedata/chartypes';

export class MyCharacter extends CharObject {
    useMoveCollision: boolean;
    mp: any;
    inventory: any;
    quests: any;
    xp: any;
    birthStone: any;
    union: any;
    fame: any;
    rank: any;
    isgm: any;
    zoneNo: number;

    constructor(world: any) {
        super(world);
      this.type = 'local';
      this.useMoveCollision = true;
      this.mp = undefined;
      this.inventory = undefined;
      this.quests = undefined;
      this.on('damage', this.changed.bind(this));
    }

    changed() {
      this.emit('changed');
    }

    getAbilityValue(abilType: any) {
      switch(abilType) {
        case ABILTYPE.STR: return this.stats.str;
        case ABILTYPE.DEX: return this.stats.dex;
        case ABILTYPE.INT: return this.stats.int;
        case ABILTYPE.CON: return this.stats.con;
        case ABILTYPE.CHA: return this.stats.cha;
        case ABILTYPE.SEN: return this.stats.sen;
        case ABILTYPE.MP: return this.mp;
        case ABILTYPE.EXP: return this.xp;
        case ABILTYPE.MONEY: return this.inventory.money;
        case ABILTYPE.BIRTH: return this.birthStone;
        case ABILTYPE.UNION: return this.union;
        case ABILTYPE.RANK: return this.rank;
        case ABILTYPE.FAME: return this.fame;
      }
      return super.getAbilityValue(abilType);
    }

    debugValidate() {
      debugValidateProps(this, [
        ['mp', 0, 999999],
        ['inventory'],
        ['quests']
      ]);
      super.debugValidate();
    }

}

/**
 * @constructor
 */
;



